import React from 'react';
import { cn } from '../../../../utils/classnames';

const SelectionButton = ({
  options = [],
  value,
  onChange,
  className = '',
  variant = 'small',
  fullWidth = false
}) => {
  const heightClass = variant === 'large' ? 'tw:h-[88px]' : 'tw:h-[50px]';
  const paddingY = variant === 'large' ? 'tw:py-4' : 'tw:py-3';

  return (
    <>
      {options.map((option) => {
        const isSelected = value === option.value;

        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`${fullWidth ? 'tw:flex-1' : ''}`}
          >
            <div className={`tw:flex tw:items-center tw:gap-3 ${heightClass} tw:rounded-[5px] ${isSelected
              ? 'tw:border-[1.5px] tw:border-[#282828] tw:font-bold'
              : 'tw:border tw:border-[#d9d9d9] tw:font-normal'
              } tw:bg-white tw:px-4 ${paddingY} ${className}`}>
              {/* Radio Indicator */}
              <div className={`tw:h-4 tw:w-4 tw:flex-shrink-0 tw:rounded-full tw:border-[1.5px] ${isSelected
                ? 'tw:border-[#282828] tw:bg-white tw:flex tw:items-center tw:justify-center tw:p-[2px]'
                : 'tw:border-[#d9d9d9]'
                }`}>
                {isSelected && (
                  <div className="tw:h-2 tw:w-2 tw:rounded-full tw:bg-[#282828]" />
                )}
              </div>

              {/* Label Content */}
              {option.subtitle ? (
                <div className={`tw:flex tw:flex-col tw:gap-0.5 ${option.maxWidth ? option.maxWidth : ''} tw:text-left tw:text-[14px] tw:lg:text-[15px]`}>
                  <span>{option.label}</span>
                  <span
                    className={`tw:font-normal tw:text-[#4e4e4e] ${option.subtitleClass || ''}`}
                    dangerouslySetInnerHTML={{ __html: option.subtitle }}
                  />
                </div>
              ) : (
                <span className={cn('tw:font-hanken-grotesk')}>{option.label}</span>
              )}
            </div>
          </button>
        );
      })}
    </>
  );
};

export default SelectionButton;
